import { FC } from "react";
import { NavLink, To } from "react-router-dom";
import { TbChevronRight } from "react-icons/tb";

interface Props {
  to: To;
  label: string;
  onClose?: () => void;
}

export const NavigationLink: FC<Props> = ({ to, label, onClose }) => {
  return (
    <NavLink
      to={to}
      onClick={onClose}
      className={({ isActive }) =>
        `
          flex items-center font-medium text-sm ${isActive ? "text-blueShades-5" : "text-blueShades-4 hover:text-blueShades-5"}
        `
      }
    >
      <span className="flex-1">{label}</span>
      <TbChevronRight className="block md:hidden" size={20} />
    </NavLink>
  );
};
